import { NODES } from "@/app/features/diagrams/functions/heroSystem/constants";

export type NetworkHoverTargetsProps = {
  handleHoverStart: (nodeId: string) => void;
  handleHoverEnd: () => void;
  handleClickNode: (nodeId: string) => void;
};

// Keeps the hit-area interaction layer independent from node rendering.
export function NetworkHoverTargets({
  handleHoverStart,
  handleHoverEnd,
  handleClickNode,
}: NetworkHoverTargetsProps) {
  return (
    <g className="hover-targets-layer pointer-events-auto">
      {NODES.map((node) => {
        const isIndustry = node.type === "industry";
        const isCenter = node.type === "center";

        return (
          <circle
            key={`target-${node.id}`}
            id={`target-${node.id}`}
            cx={node.x}
            cy={node.y}
            r={isCenter ? 16 : node.type === "capability" ? 11 : 9}
            fill="transparent"
            className={
              isIndustry ? "hidden md:block cursor-pointer" : "cursor-pointer"
            }
            onPointerEnter={() => handleHoverStart(node.id)}
            onPointerLeave={handleHoverEnd}
            onClick={() => handleClickNode(node.id)}
          />
        );
      })}
    </g>
  );
}
